import React from 'react';

const TOOTH_HEIGHT = 6;
const TOOTH_THICKNESS = 3;

/**
 * Simple gear for train visualizations (direction / speed engines).
 * @param {{ teeth?: number, size: number, color: string, accent?: string, gearRef?: import('react').RefObject, ariaLabel?: string, opacity?: number, phaseDeg?: number }} props
 */
export default function GearSvg({
  teeth = 12,
  size,
  color,
  accent = '#fff',
  gearRef,
  ariaLabel = 'Gear',
  opacity = 1,
  phaseDeg = 0,
}) {
  const t = Math.max(6, Math.round(Number(teeth) || 12));
  const r = size / 2 - 4;
  const inner = r * 0.55;
  const marks = [];
  for (let i = 0; i < t; i += 1) {
    const angle = (i / t) * 360;
    marks.push(
      <rect
        key={i}
        x={-TOOTH_THICKNESS / 2}
        y={-r}
        width={TOOTH_THICKNESS}
        height={TOOTH_HEIGHT}
        fill={color}
        transform={`rotate(${angle})`}
      />,
    );
  }
  const ph = Number(phaseDeg);
  const phase = Number.isFinite(ph) ? ph : 0;
  return (
    <svg
      viewBox={`-${size / 2} -${size / 2} ${size} ${size}`}
      ref={gearRef}
      role="img"
      aria-label={ariaLabel}
      style={{
        display: 'block',
        width: '100%',
        maxWidth: size,
        height: 'auto',
        aspectRatio: '1',
        willChange: 'transform',
        opacity,
      }}
    >
      <circle r={r - 3} fill={color} opacity={0.18} />
      <g transform={`rotate(${phase})`}>{marks}</g>
      <circle r={inner} fill={color} opacity={0.92} />
      <circle r={inner * 0.28} fill={accent} />
      <circle r={inner * 0.08} fill={color} />
    </svg>
  );
}
